import React from 'react';
import { Field } from 'formik';
import { useAuth } from '../../../context/AuthContext';

const InformationsAMAIR = ({ formikProps, sarMembershipStatus, annee }) => {
  const { errors, touched } = formikProps;
  const { user } = useAuth();

  // Déterminer si l'adhésion SAR est en attente de validation
  const isSARPending = sarMembershipStatus && ['en_attente', 'paiement_demande'].includes(sarMembershipStatus);
  const isSARActive = sarMembershipStatus === 'actif';
  const hasSARMembership = !!sarMembershipStatus;

  // Texte de la checkbox selon le statut
  const getCheckboxLabel = () => {
    if (isSARPending) {
      return `Ma demande d'adhésion SAR ${annee} est en cours de validation`;
    }
    if (isSARActive) {
      return `Je suis adhérent SAR pour ${annee}`;
    }
    return `Je suis adhérent SAR pour ${annee}`;
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          Informations AMAIR
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Informations spécifiques pour l'adhésion à l'AMAIR
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <div className="flex items-center">
            <Field
              type="checkbox"
              name="informationsSpecifiques.AMAIR.adherentSAR"
              disabled={user && hasSARMembership}
              className={`h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 ${
                user && hasSARMembership ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            />
            <label htmlFor="adherentSAR" className="ml-3 block text-sm font-medium text-gray-700">
              {getCheckboxLabel()}
            </label>
          </div>
          
          {/* Message explicatif selon le statut */}
          {!hasSARMembership && (
            <p className="mt-1 ml-7 text-xs text-gray-500">
              Si vous êtes adhérent SAR pour {annee}, l'adhésion AMAIR est gratuite (0€). Sinon, elle est de 50€.
            </p>
          )}
          
          {/* Message pour adhésion SAR active */}
          {user && isSARActive && (
            <p className="mt-2 ml-7 text-xs text-green-600">
              Vous êtes adhérent SAR {annee}, vous bénéficiez donc de l'adhésion AMAIR gratuite.
            </p>
          )}
          
          {/* Message pour adhésion SAR en attente */}
          {user && isSARPending && (
            <div className="mt-2 ml-7 p-3 rounded-md bg-honey-50 border border-honey-200">
              <p className="text-xs text-honey-800">
                <strong>Votre demande d'adhésion SAR {annee} est en cours de validation.</strong>
              </p>
              <p className="mt-1 text-xs text-honey-700">
                Une fois votre adhésion SAR validée, votre adhésion AMAIR sera également validée automatiquement 
                et vous bénéficierez de la gratuité.
              </p>
            </div>
          )}
          
          {/* Avertissement pour utilisateur non connecté */}
          {!user && formikProps.values.informationsSpecifiques?.AMAIR?.adherentSAR && (
            <p className="mt-2 ml-7 text-xs text-honey-600">
              Attention : Si vous êtes adhérent SAR pour {annee}, vous devez vous connecter à votre espace adhérent pour continuer.
            </p>
          )}

          {/* Avertissement pour utilisateur connecté sans adhésion SAR */}
          {user && !hasSARMembership && formikProps.values.informationsSpecifiques?.AMAIR?.adherentSAR && (
            <div className="mt-2 ml-7 p-3 rounded-md bg-red-50 border border-red-200">
              <p className="text-xs text-red-800">
                <strong>Vous n'avez pas d'adhésion SAR pour {annee}.</strong>
              </p>
              <p className="mt-1 text-xs text-red-700">
                Pour bénéficier de la gratuité AMAIR, vous devez d'abord créer votre adhésion SAR pour {annee}, 
                ou décocher cette option pour payer l'adhésion AMAIR (50€).
              </p>
            </div>
          )}
          
          {errors.informationsSpecifiques?.AMAIR?.adherentSAR && touched.informationsSpecifiques?.AMAIR?.adherentSAR && (
            <p className="mt-2 text-sm text-red-600">{errors.informationsSpecifiques.AMAIR.adherentSAR}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InformationsAMAIR;
